<div class="button-toolbar">
  <div style="display: flex; justify-content: space-between; align-items:flex-start;">
    <div style="align-items:flex-start">
      <div class="btn-group" role="group">
        <span class="d-inline-block" data-bs-toggle="tooltip" title="Reset">
          <button type="button" class="btn btn-light dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
            Reset
          </button>
          <ul class="dropdown-menu">
            <li>
              <span class="d-inline-block full-width" data-bs-toggle="tooltip"
                title="Reload the application from the server">
                <a class="dropdown-item" (click)="onButtonAction('resetApplication','')">Application</a>
              </span>
            </li>
            <li>
              <span class="d-inline-block full-width" data-bs-toggle="tooltip" title="Reset the section currently selected">
                <a class="dropdown-item" (click)="onButtonAction('resetSection','')">Section</a>
              </span>
            </li>
          </ul>
        </span>
      </div>
      <button *ngIf="isFirstStep()" type="button" class="btn btn-light" [disabled]="this.disableCount"
        aria-label="Counts number of products that will be exported" title="Counts the number of products that will be exported based on the specified condition(s)"
        (click)="onButtonAction('count','')">{{this.getCountLabel()}}</button>
      
      <button *ngIf="isFirstStep()" type="button" class="btn btn-light"
        aria-label="Request products that meets selected filters" title="Request the export of products that meets the specified condition(s)"
        (click)="onButtonAction('request','')">Request</button>
      
      <button *ngIf="isSecondStep()" type="button" class="btn btn-light" aria-label="" title="Refresh to see the most recent requests"
        (click)="onButtonAction('refresh')">Refresh List</button>

      <div *ngIf="isSecondStep()" class="btn-group" role="group">
        <span class="d-inline-block" data-bs-toggle="tooltip" title="Operations">
          <button type="button" class="btn btn-light dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false" title="Operations">
            Operations
          </button>
          <ul class="dropdown-menu">
            <li *ngIf="isCancelable()">
              <span class="d-inline-block full-width" data-bs-toggle="tooltip"
                title="Cancel the request in progress">
                <a class="dropdown-item" (click)="onButtonAction('cancelRequest')">Cancel</a>
              </span>
            </li>
            <li *ngIf="isDownloadable()">
              <span class="d-inline-block full-width" data-bs-toggle="tooltip"
                title="Download the completed request">
                <a class="dropdown-item" (click)="onButtonAction('downloadRequest')">Download</a>
              </span>
            </li>
            <li *ngIf="isArchivable()">
              <span class="d-inline-block full-width" data-bs-toggle="tooltip"
                title="Delete the completed request">
                <a class="dropdown-item" (click)="onButtonAction('archiveRequest')">Delete</a>
              </span>
            </li>
            <li *ngIf="!hasActions()">
              <span class="d-inline-block full-width" data-bs-toggle="tooltip"
                title="No operations available">
                &nbsp;No operations available&nbsp; 
              </span>
            </li>
          </ul>
        </span>
      </div>
    </div>

    <div *ngIf="isSecondStep()" style="align-items:flex-end">

      <button *ngIf="!isFirstPage()" type="button" class="btn btn-light" aria-label="Back to top" title="Back to top"
        (click)="onButtonAction('firstPage')"><i class="pi pi-arrow-up"></i></button>

      <button *ngIf="!isFirstPage()" type="button" class="btn btn-light" aria-label="Get previous Page" title="Get previous Page"
        (click)="onButtonAction('previousPage')"><i class="pi pi-arrow-left"></i></button>

      <button *ngIf="hasNextPage()" type="button" class="btn btn-light" aria-label="Get next Page" title="Get next Page"
        (click)="onButtonAction('nextPage')"><i class="pi pi-arrow-right"></i></button>
    </div>
  </div>
</div>